import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { CasMetadataNode } from '../../classes/CasMetadataNode';
import { DynamicComponent } from './dynamic/dynamic.component';

@Component({
  moduleId: module.id,
  selector: 'application-form-question-traverse',
  templateUrl: './application-form-question-traverse.component.html',
})
export class ApplicationFormQuestionTraverseComponent implements OnInit {
  @ViewChild('root', { static: true }) dynamicComponent: DynamicComponent;
  @Input() childQuestion: CasMetadataNode;
  @Input() loopIndex: number = NaN;

  constructor() {}

  remove() {
    this.dynamicComponent.destroy();
  }

  ngOnInit() {}

  isIterate() {
    return this.childQuestion.controlType.match(/iterate/);
  }

  isDiagnosis() {
    return this.childQuestion.type && this.childQuestion.type.match(/Diagnosis/);
  }
}
